import React, { useEffect, useLayoutEffect, useContext } from "react";
import { View } from "react-native";
import MyAddresses from "../../../../Diathrive/src/containers/MyAddresses";
import { useNavigate, useOutletContext } from "react-router-dom";
import { COLORS } from "../../../../Diathrive/src/utils/Constants";
import Text from "../../../../Diathrive/src/components/elements/Text";
import styles from "./styles";
import { tID } from "../../../../Diathrive/src/utils/TestIdHelper";
import RightPannel from "../../components/RightPannel";
import EditAddress from "../../../../Diathrive/src/containers/EditAddress";
import { shopContext } from "../../../../Diathrive/src/contexts/ShopContext";
import { LeftArrowIcon } from "../../../../Diathrive/src/utils/SvgIcons";
import CommonStyles from "../../../../Diathrive/src/utils/CommonStyles";

const HeaderText = () => (
  <View
    testID={tID("ShippingAddresses-View-HeaderContainer")}
    style={styles.headerTextContainer}
  >
    <Text
      testID={tID("ShippingAddresses-Text-ModuleTitle")}
      variation="Text2Medium"
      color={COLORS.grey3}
    >
      Settings
    </Text>
    <LeftArrowIcon style={CommonStyles.mh_12} />
    <Text
      testID={tID("ShippingAddresses-Text-ScreenTitle")}
      variation="Text2SemiBold"
      color={COLORS.blueDarkText}
    >
      My Addresses
    </Text>
  </View>
);

const ShippingAddresses = () => {
  const navigate = useNavigate();
  const { setHeaderName } = useOutletContext();
  const ShopC = useContext(shopContext);

  useLayoutEffect(() => {
    if (setHeaderName) setHeaderName(<HeaderText />);
  }, [setHeaderName]);

  useEffect(() => {
    if (ShopC?.addOrEditAddress) window.scrollTo(0, 0); //Scroll to top if address is going to add or edit
  }, [ShopC?.addOrEditAddress]);

  return (
    <>
      <MyAddresses
        navigation={navigate}
        setAddOrEditAddress={ShopC?.setAddOrEditAddress}
        addOrEditAddress={ShopC?.addOrEditAddress}
      />
      <RightPannel
        componentToPassDown={
          <EditAddress
            navigation={navigate}
            route={{
              params:
                typeof ShopC?.addOrEditAddress === "boolean"
                  ? {}
                  : { addressData: ShopC?.addOrEditAddress },
            }}
            setAddOrEditAddress={ShopC?.setAddOrEditAddress}
          />
        }
        open={ShopC?.addOrEditAddress}
        onClose={() => ShopC?.setAddOrEditAddress(false)}
      />
    </>
  );
};

export default ShippingAddresses;
